<template>
    <div class="page max-content">
        <div class="info">
            <p>订单状态</p>
            <p v-if="info.status">支付成功</p>
        </div>
        <div class="info">
            <p>订单编号</p>
            <p>{{ info.out_trade_no }}</p>
        </div>
        <div class="info">
            <p>支付总额</p>
            <p>¥{{ info.amount }}</p>
        </div>
        <div class="info">
            <p>支付成功时间</p>
            <p>{{ info.updated_at }}</p>
        </div>
        <div class="btn" @click="next">去开票</div>
    </div>

</template>

<script>
import { orderDetail } from '../../../config/interface.js'

export default {
    data() {
        return {
            info: {}
        }
    },
    computed: {
        out_trade_no() {
            return this.$route.query.out_trade_no;
        }
    },
    mounted() {
        this.loadScript()
        
    },
    methods: {
        loadScript() {
            let that=this
            // 创建一个新的 script 元素
            const script = document.createElement('script');
            // 设置 script 的属性
            script.src = 'https://wx.gtimg.com/pay_h5/goldplan/js/jgoldplan-1.0.0.js'; // 替换为实际的脚本 URL
            script.type = 'text/javascript';
            // 监听脚本加载完成事件
            script.onload = () => {
                console.log('脚本加载完成');
                that.getDetail();

            };
            script.onerror = () => {
                console.error('脚本加载失败');
            }
            // 将 script 元素插入到 DOM 中
            document.head.appendChild(script);
        },

        getDetail() {
            const url = orderDetail;
            let params = {
                out_trade_no: this.out_trade_no,
            }
            const method = "POST";
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        this.info = res.data
                        console.log(res.data)
                        this.$nextTick(() => {
                            let mchData = { action: 'onIframeReady', displayStyle: 'SHOW_CUSTOM_PAGE' }
                            let postData = JSON.stringify(mchData)
                            parent.postMessage(postData, 'https://payapp.weixin.qq.com')
                        })
                    }
                })
        },
        next() {
            let mchData = { action: 'jumpOut', jumpOutUrl: 'https://xgzx.talkmed.com/vascularNews/chargeInfo/collectInfo?type=1&step=3&meeting_id=' + this.info.meeting_id }
            let postData = JSON.stringify(mchData)
            parent.postMessage(postData, 'https://payapp.weixin.qq.com')
        }
    },
}

</script>

<style lang="scss" scoped>
.page {
    display: flex;
    height: 100vh;
    flex-direction: column;
    align-items: center;
    padding-top: 15%;

    .info {
        width: 90%;
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        margin-block: 15px;
        color: #999;

        >p:last-child {
            color: #333;
        }

    }

    .btn {
        width: 165px;
        height: 45px;
        line-height: 45px;
        text-align: center;
        color: #fff;
        margin: 30px auto 0;
        border-radius: 5px;
        background: #901D22;
        font-size: 16px;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/ChargeInfo/orderInfo.vue